let language = {
    // TODO billing-method-list.controller的多语言
    "BILLING-METHOD-LIST-ADD-BUTTON": "添加新的支付方式",
    "BILLING-METHOD-EMPTY-TIPS-HERE": "这里",
    "BILLING-METHOD-EMPTY-TIPS": "您的支付方式为空",
    "BILLING-METHOD-EMPTY-ADD-TIP":"添加新的支付方式",
    "BILLING-METHOD-TABLE-TIPS-ACCOUNT": "账户",
    "BILLING-METHOD-TABLE-TIPS-BILLINGMETHOD": "支付方式",
    "BILLING-METHOD-TABLE-TIPS-FIRSTNAME": "名字",
    "BILLING-METHOD-TABLE-TIPS-LASTNAME": "姓氏",
    "BILLING-METHOD-TABLE-TIPS-OPERATION": "操作",
    "BILLING-METHOD-STATUS-DEFAULT": "默认",
    "BILLING-METHOD-STATUS-BUTTON-SET-DETAULT": "设为默认",
    "BILLING-METHOD-ALERT-DELETE-CONTENT": "您确定要删除此支付方式吗？",
    "BILLING-METHOD-ALERT-SET-DEFAULT-TITLE": "设置为默认支付方式",
    "BILLING-METHOD-ALERT-SET-DEFAULT-CONTENT": "您确定要设置为默认支付方式吗？",
    "BILLING-METHOD-ALERT-SET-DEFAULT-SUCCESS": "成功设置默认支付方式",
    "BILLING-METHOD-DELETE-TITLE": "删除支付方式",
    "BILLING-METHOD-SUCCESS-DELETE": "成功删除支付方式",
    "BILLING-METHOD-DELETE-ONLY-DEFAULT-METHOD": "这是我们用于您未来交易的默认方式。您确定要删除此默认支付方式吗？",
    "BILLING-METHOD-RESET-DEFAULT-BILLING-METHOD": "默认支付方式已被删除，请添加或设置一个默认支付方式。",
    
    "BILLING-METHOD-ADD-MANUALLY": "手动添加",
    "BILLING-METHOD-IMPORT-FROM-ADDRESS-BOOK": "从地址簿导入",
    "BILLING-METHOD-TITLE": "支付方式",
    "BILLING-METHOD-INFO-TITLE": "支付信息",
    "BILLING-METHOD-SET-AS-PRIMARY": "设为账户主要支付方式",
    "BILLING-METHOD-ADD-BTN": "添加",
    "BILLING-METHOD-PAYPAL-TYPE": "Paypal",
    
    "BILLING-METHOD-ADD-FAIL-TITLE": "添加失败",
    "BILLING-METHOD-ALREADY-BEEN-ADD": "此支付方式已添加，请勿重复添加。",
};

export { language }
